module.exports = __webpack_public_path__ + "img/home-solution-huoqing.9bd6e35d.png";